import useExpDetailsProjectTemplate from './template/useExpDetailsProjectTemplate';
import useExpDetailsPersonalTemplate from './template/useExpDetailsPersonalTemplate';
import { SelectedExpDetailsTemplate } from '@experiment-details/types';
import useExpDetailsSelectedTemplateId from './useExpDetailsSelectedTemplateId';

const useExpDetailsSelectedTemplate = (): SelectedExpDetailsTemplate => {
  const selectedTemplateId = useExpDetailsSelectedTemplateId();

  const projectTemplate = useExpDetailsProjectTemplate({
    templateId: selectedTemplateId
  });
  const personalTemplate = useExpDetailsPersonalTemplate();

  return selectedTemplateId ? projectTemplate : personalTemplate;
};

export default useExpDetailsSelectedTemplate;
